import { useQuery } from '@tanstack/react-query';
import { UrlMetadataResult } from 'src/@types/url';
import { DocsRequests } from 'src/requests/docs';

export const useUrlMetadataQuery = (
  url: string,
  initialData?: UrlMetadataResult,
) => {
  const { data, isLoading, isRefetching } = useQuery({
    queryKey: ['embedMetadata', url],
    initialData: initialData,
    keepPreviousData: true,
    enabled: !initialData,
    queryFn: () => DocsRequests.fetchUrlMetadata(url),
    refetchInterval: false,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return { data, isLoading, isRefetching };
};
